exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-icon-loading[data-v-3be24aed]:before{font-size:100px}.result[data-v-3be24aed]{margin-top:100px}.danger-color[data-v-3be24aed]{color:red}.hand_test[data-v-3be24aed]{float:right}.card-header-my[data-v-3be24aed]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:.75rem}", ""]);

// exports
